import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { MediaService } from 'app/API';
import type { TGenerateUploadParams } from './types/TGenerateUploadParams';

export const useJobUploadParamsMutation = (): TGenerateUploadParams => {
  const { call } = useAPI();
  const { mutateAsync } = useMutation({
    mutationFn: ({ objectId, file }: Parameters<TGenerateUploadParams>[0]) =>
      call(() => MediaService.generateUploadParams({ jobId: objectId, file })),
  });
  return mutateAsync;
};
